import { render, staticRenderFns } from "./SelectTypeColumn.vue?vue&type=template&id=11c0e550&scoped=true&"
import script from "./SelectTypeColumn.vue?vue&type=script&lang=js&"
export * from "./SelectTypeColumn.vue?vue&type=script&lang=js&"
import style0 from "./SelectTypeColumn.vue?vue&type=style&index=0&id=11c0e550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0e550",
  null
  
)

export default component.exports